import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Layout
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

// Error Boundary and Loading
import ErrorBoundary from './components/ErrorBoundary';
import LoadingSpinner from './components/LoadingSpinner';
import ScrollToTop from './components/ScrollToTop';
import { ParticipantAuthProvider } from './context/ParticipantAuth';

// Lazy load pages for code splitting
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Research = lazy(() => import('./pages/Research'));
const Training = lazy(() => import('./pages/Training'));
const CourseDetail = lazy(() => import('./pages/CourseDetail'));
const ModulePage = lazy(() => import('./pages/ModulePage'));
const UnitPage = lazy(() => import('./pages/UnitPage'));
const LearnAuth = lazy(() => import('./pages/LearnAuth'));
const LearnDashboard = lazy(() => import('./pages/LearnDashboard'));
const LearnPayment = lazy(() => import('./pages/LearnPayment'));
const Services = lazy(() => import('./pages/Services'));
const ServiceRequest = lazy(() => import('./pages/ServiceRequest'));
const Partnerships = lazy(() => import('./pages/Partnerships'));
const News = lazy(() => import('./pages/News'));
const Contact = lazy(() => import('./pages/Contact'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Terms = lazy(() => import('./pages/Terms'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const NotFound = lazy(() => import('./pages/NotFound'));

function App() {
  return (
    <ErrorBoundary>
      <ParticipantAuthProvider>
      <ScrollToTop />
      <div className="app">
        <Navbar />
        <main className="main-content">
          <Suspense fallback={<LoadingSpinner message="Loading page..." />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/research" element={<Research />} />
              <Route path="/training" element={<Training />} />
              <Route path="/training/:courseId" element={<CourseDetail />} />
              <Route path="/training/:courseId/module" element={<ModulePage />} />
              <Route path="/training/:courseId/module/:unitId" element={<UnitPage />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/request" element={<ServiceRequest />} />
              <Route path="/service-request" element={<ServiceRequest />} />
              <Route path="/partnerships" element={<Partnerships />} />
              <Route path="/news" element={<News />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/learn" element={<LearnDashboard />} />
              <Route path="/learn/pay/:courseId" element={<LearnPayment />} />
              <Route path="/learn/:mode" element={<LearnAuth />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <ToastContainer position="top-right" autoClose={5000} />
      </div>
      </ParticipantAuthProvider>
    </ErrorBoundary>
  );
}

export default App;
